// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"617aea73","154":"0ce43763","159":"c2176b47","206":"db992a71","292":"a9e7668d","412":"f1a93840","696":"007d7dcb","761":"6974cb5e","787":"4f57ac2b","804":"fce9112e","917":"7528d681","956":"b313f104"}[chunkId] + ".chunk.js";
};